import { useState } from 'react';

// A touch phone/tablet by user agent, independent of PWA install state.
// (Unlike isAndroidDevice/isIosDevice, which report false once the app is installed)
export function useIsMobileDevice(): boolean {
  const [isMobile] = useState(() => {
    if (typeof window === 'undefined') return false;

    const ua = window.navigator.userAgent;
    const isPhone = /android|iphone|ipad|ipod/i.test(ua);
    const isIpadOs = /macintosh/i.test(ua) && navigator.maxTouchPoints > 2;
    return isPhone || isIpadOs;
  });

  return isMobile;
}
